import * as t from 'io-ts';
export var PopoverConfig = t.type({
  messagingEnabled: t["boolean"]
});